import Fade from '@mui/material/Fade';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { viewAboutMeEnabled } from '../atoms/Header-Atoms'
import { useRecoilValue } from 'recoil';
import BioShot from '../images/jb-port.png';
import LeftPanelBackground from '../images/about-background-left.svg';

function AboutMe() {
    const enabled = useRecoilValue(viewAboutMeEnabled);

    const ItemLeft = styled(Paper)(({ theme }) => ({
        textAlign: 'left',
        fontSize: 18,
        color: theme.palette.text.secondary,
        minHeight: 500,
        backgroundImage: `url(${LeftPanelBackground})`,
        backgroundSize: "cover"
    }));

    const ItemRight = styled(Paper)(({ theme }) => ({
        minHeight: 500,
        backgroundImage: `url(${BioShot})`,
        backgroundSize: "cover"
    }));

    return (
        <Fade in={enabled} timeout={{ enter: 400, exit: 400 }}>
            <div id="section-1" className="contentModule">
                <Grid container spacing={2}>
                    <Grid item xs={4} md={6}>
                        <ItemLeft>
                            <div className="leftPanel">
                                <h3>About Me</h3>
                                <p>Greetings, I’m a creative technologist, builder, and product leader. I thrive at the intersection of creativity and technology, moving fluidly between art, design, and software.</p>
                                <p>I create across traditional and digital mediums, and have applied those skills to software for applications and the web. Over the years, I’ve used a wide range of tools, mediums, and programming languages to bring ideas to life. While I no longer focus on hands-on coding, that technical foundation continues to shape how I approach problem solving and building things.</p>
                                <p>For two decades, I’ve led teams and products, guiding software development groups, shaping the direction of projects, and supporting the people who make them successful.</p>
                                <p>Creating is a constant in my life, whether on a screen, with my hands, or through processes that blend craft, experimentation, and iteration. Making things, in any medium, is a thread that ties all of my work together.</p>
                                <p>For a more complete overview of my professional experience, please visit my <a href="https://www.linkedin.com/in/johnbrickner/" target="_blank">LinkedIn</a> profile.</p>
                            </div>
                        </ItemLeft>
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <ItemRight></ItemRight>
                    </Grid>
                </Grid>
            </div>
        </Fade>      
    );
}

export default AboutMe;